(function($) {

    $.fn.showLoader = function() {
        //Modal components
        var $loader = $('<div class="loader">Loading<div class="animate-container"><div class="animate-bg"></div><div class="mask"></div></div><div class="heggie"></div></div>');

        //Build the basic loader and prepend to <body>
        var $builtLoader = $loader;
        $('body').prepend($builtLoader);
        //After adding elements to the DOM, use getComputedStyle to force the browser to recalc and recognize the elements that we just added. This is so that CSS animation has a start point
        var loaderElement = document.getElementsByClassName('loader')[0];
        window.getComputedStyle(loaderElement).height;

        //Now it is built, show the loader
        $loader.addClass('loading');

        return this;
    };




    $.fn.hideLoader = function() {
        var $loader = $('.loader');

        //Remove the open class name
        $loader.removeClass('loading');

        //Listen for CSS transitionend event and then remove the nodes from the DOM
        $loader.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
            $loader.remove();
        });

        return this;
    };




    $.fn.btnLoader = function($targetBtn, options) {
        var $spinner = $('<div class="spin-loader"><span class="icon icon-M"></span></div>');

        //Default options.
        var settings = $.extend({
            dark: false,
        }, options);

        //Check if settings exists and build elements if so
        if (settings.dark === true) {
            $spinner.addClass('dark');
        }

        //If the button doesn't have position relative or absolute, set to relative so we can position the spinner
        //We do this because we don't want to be setting any buttons that are positoned absolute to relative as it could break the layout
        if ($targetBtn.css('position') !== 'relative') {
            if ($targetBtn.css('position') !== 'absolute') {
                $targetBtn.css('position', 'relative');
            }
        }

        $targetBtn.append($spinner);
        $targetBtn.addClass('loading').attr('disabled', true);

        return this;
    };




    $.fn.hideBtnLoader = function($targetBtn) {
        //If a target button is specified remove it from that button only, if not then remove it from all buttons
        if ($targetBtn) {
            $targetBtn.find('.spin-loader').remove();
            $targetBtn.removeClass('loading').attr('disabled', false);
        } else {
            $('.btn.loading').find('.spin-loader').remove();
            $('.btn.loading').removeClass('loading').attr('disabled', false);
        }

        return this;
    };




    $.fn.lazyLoad = function($targetElem, options) {
        var $spinner = '<div class="lazy-load"><div class="spin-loader dark"><span class="icon icon-L"></span></div></div>';

        //Default options.
        var settings = $.extend({
            absolute: false,
        }, options);

        $targetElem.append($spinner);
        $targetElem.find($('.lazy-load')).addClass('loading');

        //Check if settings exists and build elements if so
        if (settings.absolute === true) {
            if ($targetElem.css('position') !== 'relative') {
                if ($targetElem.css('position') !== 'absolute') {
                    $targetElem.css('position', 'relative');
                }
            }

            $targetElem.find($('.lazy-load')).addClass('lazy-load-absolute');
        }

        return this;
    };




    $.fn.hideLazyLoad = function($targetElem) {
        //If a target button is specified remove it from that elem only, if not then remove it from all buttons
        if ($targetElem) {
            $targetElem.find('.lazy-load.loading').remove();
        } else {
            $('.lazy-load.loading').remove();
        }

        return this;
    };

}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/loader.js